<template>
  <div>
    <SpForm ref="jobInfoForm" v-model="jobInfo" @submit="submit">
      <div class="AddResponsibilities">
        <div class="content flex-jc-bt">
          <div class="flex-48">
            <sp-card>
              <div class="pd-l-20 pd-r-20">
                <div class="clearfix">
                  <sp-select v-if="!routerQuery.id" v-model="jobInfo.identity" class="float-r small-select" name="identity" height="32" width="167" type="warn" :disabled="!!routerQuery.id"
                             :text-style="{fontSize: '12px'}" @after-select="(val) => searchProfession(val, '',true)">
                    <sp-select-option v-for="(item, key) in deptIdentity" :key="key" :value="key" :label="$l(item.title)"
                                      type="primary" />
                  </sp-select>
                  <sp-input v-else v-model="deptIdentityTitle" :text-style="{fontSize: '12px'}" height="32" width="167" class="float-r" :disabled="!!routerQuery.id" type="gray" />
                  <span class="float-r" style="line-height: 32px; margin-right: 6px">{{ $l('DeptAccessIdentity') }}</span>
                </div>
                <div v-triangle class="fw-bold pd-t-20 text-left">
                  {{ $l('JobTitleDescription') }}
                </div>
                <div class="pd-l-20 text-left">
                  <div class="flex-jc-bt">
                    <div class="flex-1 mg-r-20 mg-t-20">
                      <div class="font18 italic position-title">{{ $l('Responsibility') }}</div>
                      <sp-select v-if="!routerQuery.id" v-model="jobInfo.professionId" :custom-selection-disable="false" type="warn"
                                 :disabled="!!routerQuery.id" @after-select="searchPosition">
                        <sp-select-option v-for="pro in professionOptions" :key="pro.id" :value="pro.id" :label="pro.name"
                                          type="primary" />
                      </sp-select>
                      <sp-input v-else v-model="jobInfo.profession.name" :disabled="!!routerQuery.id" type="gray" />
                    </div>
                    <div class="flex-1 mg-t-20">
                      <div class="font18 italic position-title">{{ $l('Position') }}</div>
                      <sp-select v-if="!routerQuery.id" v-model="jobInfo.positionId" :custom-selection-disable="false" type="warn" :disabled="!!routerQuery.id">
                        <sp-select-option v-for="pos in positionOptions" :key="pos.id" :value="pos.id" :label="pos.name"
                                          type="primary" />
                      </sp-select>
                      <sp-input v-else v-model="jobInfo.position.name" :disabled="!!routerQuery.id" type="gray" />
                    </div>
                  </div>
                </div>
                <div class="mg-t-30 pd-l-20 three-dimensional-small">
                  <div class="top" style="width: 98%" />
                  <div class="flex-al-center">
                    <div class="left"
                         :style="{'height': identityPermissionMap?.permissions ? (Object.keys(identityPermissionMap?.permissions).length * 47 +47 +4) +'px' : '287px'}" />
                    <div v-if="identityPermissionMap?.permissions"
                         class="dimensional-content flex-1"
                         :style="{'height': identityPermissionMap?.permissions ? (Object.keys(identityPermissionMap?.permissions).length * 47 +47 +4) +'px' : '287px'}">
                      <div v-for="(per, key, index) in identityPermissionMap.permissions" v-if="identityPermissionMap?.permissions"
                           :class="{'odd': index%2}"
                           class="content-item flex-jc-start">
                        <div class="font18 italic item-title">
                          {{ key }} :
                        </div>
                        <div class="flex-1 text-left">
                          <div class="flex-jc-start">
                            <div v-for="(ch, chKey, index) in per" class="flex-1">
                              <!--                              <el-checkbox v-model="checked">备选项</el-checkbox> -->
                              <el-checkbox v-if="jobInfo.generalPermission[camelCase(key)]" v-model="jobInfo.generalPermission[camelCase(key)][camelCase(chKey)]"
                                           :true-label="1"
                                           :false-label="0"
                                           class="comp-radio mg-r-40"
                                           icon-type="checkbox"
                                           :disabled="index===1 && jobInfo.generalPermission[camelCase(key)][Object.keys(per).map(p => camelCase(p))[0]] !==1"
                                           :name="`jobInfo.generalPermission.${camelCase(key)}.${camelCase(chKey)}`"
                                           @click="!(index===1 && jobInfo.generalPermission[camelCase(key)][Object.keys(per).map(p => camelCase(p))[0]] !==1) ?toChangePermission(jobInfo.generalPermission[camelCase(key)][camelCase(chKey)], ch, camelCase(key), camelCase(chKey), Object.keys(per).map(p => camelCase(p))) : null">
                                <p class="font18 radio-label sp-color-11">{{ chKey }}</p>
                              </el-checkbox>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div style="height: 4px; background-color:#fff;" />
                      <div class="blue content-item flex-jc-start">
                        <div class="font18 italic item-title" style="font-size: 17px">
                          {{ $l('RightToCompleteDeletion') }}
                        </div>
                        <div class="flex-1 text-left">
                          <el-checkbox v-model="jobInfo.delPriv" :true-label="1" class="comp-radio" :false-label="0">
                            <p class="font18 radio-label sp-color-11">{{ $l("DeleteTheContent") }}</p>
                          </el-checkbox>
                        </div>
                      </div>
                    </div>
                    <div v-else class="dimensional-content flex-1">
                      <div v-for="(per, index) in 5"
                           :class="{'odd': index%2}"
                           class="content-item flex-jc-start">
                        <div class="font18 italic item-title">
                          {{ key }}
                        </div>
                        <div class="flex-1 text-left" />
                      </div>
                      <div style="height: 4px; background-color:#fff;" />
                      <div class="blue content-item flex-jc-start">
                        <div class="font18 italic item-title" style="font-size: 17px">
                          <!--                          {{ $l('RightToCompleteDeletion') }} -->
                        </div>
                        <div class="flex-1 text-left" />
                      </div>
                    </div>
                  </div>
                  <div class="mg-t-20 pd-l-20">
                    <div class="text-left">
                      <span class="font18 italic position-title">{{ $l('JobDescription') }}</span>
                      <div class="">
                        <sp-input v-model="jobInfo.description" name="description" type="warn3" text-type="textArea" row="10" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </sp-card>
          </div>
          <div class="flex-50 right-side">
            <div class="flex-jc-end">
              <spButton class="mg-r-20" circle-radius="5" type="back" :width="240" :height="70">
                <span class="font-bold font18">{{ $l('back') }}</span>
              </spButton>
              <spButton type="primary" circle="5" html-type="submit" :label="$L('submit')" :width="240" :height="70">
                <span class="font-bold font18">{{ $l('Submit') }}</span>
              </spButton>
            </div>
            <div class="mg-t-10 sp-color-bg-4">
              <div class="card-content">
                <P class="font18 italic text-center">{{ $l('DetailsSystem') }}</P>
                <div v-triangle class="text-left">
                  {{ $l('PermissionsDetails') }}
                </div>
                <div class="mg-t-20">
                  <ElementPlusTree
                    ref="permissionsTree"
                    :default-checked-keys="defaultCheckedKeys"
                    :identity="parseInt(jobInfo.identity)"
                    :permission="permission"
                    :state="!routerQuery.id ? 'add' : ''"
                    @setCheckedKeys="setCheckedKeys"
                    @setLeftMap="setGeneralPermission"
                  />
                </div>
                <P class="font18 italic text-center">{{ $l('PermissionsQuestionsContact') }} <span class="font-bold sp-color-1">Email : QA@shiplus.net</span></P>
              </div>
            </div>
          </div>
        </div>
      </div>
    </SpForm>
  </div>
</template>

<script type="text/ecmascript-6">
import spInput from '@/components/common/SpInput'
import spSelect from '@/components/common/SpSelect'
import spSelectOption from '@/components/common/SpSelectOption'
import spCard from '@/components/common/SpCard'
import spTag from '@/components/common/SpTag'
import spTagGroup from '@/components/common/SpTagGroup'
import spRadio from '@/components/common/SpRadio'
import spRadioGroup from '@/components/common/SpRadioGroup'
import spButton from '@/components/common/SpButton'
import {
  DEPT_IDENTITY
} from '@/config/company'
import {
  getOptionsJobProfessionApi,
  getOptionsJobPositionApi,
  getPermissionTreeApi,
  enterpriseJobEditApi, getEnterpriseJobDetailApi, enterpriseJobCopyApi
} from '@/request/APIs/company'
import SpForm from '@/components/common/SpForm'
import SpMessage from '@/components/common/SpMessage'
import ElementPlusTree from '@/components/common/ElementPlusTree'
import { getJobPermissionMapApi } from '@/request/APIs/common'
import _forEach from 'lodash/forEach'
import _camelCase from 'lodash/camelCase'
import _without from 'lodash/without'
import _includes from 'lodash/includes'
import _intersection from 'lodash/intersection'
import _uniq from 'lodash/uniq'

import { nextTick } from '@vue/runtime-core'

export default {
  name: 'AddResponsibilities',
  nameSpace: 'company.AddResponsibilities',
  components: {
    ElementPlusTree,
    SpForm,
    spInput,
    spSelect,
    spSelectOption,
    spCard,
    spTag,
    spTagGroup,
    spRadio,
    spRadioGroup,
    spButton
  },

  data () {
    return {
      type: 'PublishingCenter',
      jobInfo: {
        permissionIds: {},
        profession: {},
        position: {},
        generalPermission: {

        },

        delPriv: 1
      },

      deptIdentity: DEPT_IDENTITY,
      professionOptions: [], // 职务
      positionOptions: [], // 职位
      permission: {},
      permissionTree: {}, // 权限结构
      allCheck: {},
      camelCase: _camelCase,
      checkPermissionIds: [],
      defaultCheckedKeys: [],
      jobPermissionMap: {},
      psArr: []
    }
  },

  computed: {
    routerQuery () {
      return this.$route.query
    },

    deptIdentityTitle () {
      return this.deptIdentity[this.jobInfo.identity]?.title
    },

    identityPermissionMap () {
      const i = parseInt(this.jobInfo.identity) || parseInt(this.routerQuery.identity)
      return this.jobPermissionMap[i]
    }
  },

  watch: {
    identityPermissionMap: {
      handler (val) {
        if (val && !this.routerQuery.id) {
          this.setJobGeneralPermission()
        }
      }
    }
  },

  created () {
    this.getJobPermissionMap()
  },

  mounted () {
    if (this.routerQuery.identity) {
      this.jobInfo.identity = this.routerQuery.identity
      this.searchProfession(this.jobInfo.identity, '', true)
    }

    this.getEnterpriseCorpDetail()
  },

  methods: {
    setCheckedKeys (keys) {
      this.checkPermissionIds = keys
    },

    // 获取职务选项 和 权限结构
    searchProfession (identity, type, set) {
      this.jobInfo.permissionIds = {}
      this.allCheck = {}
      if (type !== 'auto') {
        this.jobInfo.professionId = null
        this.jobInfo.positionId = null
      }

      getOptionsJobProfessionApi(identity, 1).then(res => {
        this.professionOptions = res.data
      })
      getPermissionTreeApi(identity).then(res => {
        this.permission = []
        this.permission = res.data
        this.getPermissionTreeArr(this.permission[`n-${this.jobInfo.identity}` || this.jobInfo.identity].subs, set)
      })
      if (set) {
        this.setJobGeneralPermission()
      }
    },

    getPermissionTreeArr (permission, set) {
      _forEach(permission, ps => {
        if (ps.subs) {
          this.psArr.push({
            id: ps.id,
            parentId: ps.parentId
          })
          if (set) {
            this.defaultCheckedKeys.push(ps.id)
          }

          this.getPermissionTreeArr(ps.subs, set)
        } else {
          this.psArr.push({
            id: ps.id,
            parentId: ps.parentId
          })
          if (set) {
            this.defaultCheckedKeys.push(ps.id)
          }
        }
      })
    },

    // 获取职位选项
    searchPosition (profession) {
      getOptionsJobPositionApi(profession, 1).then(res => {
        this.positionOptions = res.data
      })
    },

    submit () {
      const jobInfo = JSON.parse(JSON.stringify(this.jobInfo))
      this.checkPermissionIds.push(parseInt(this.jobInfo.identity))
      const params = {
        identity: jobInfo.identity,
        profession: jobInfo.professionId,
        position: jobInfo.positionId,
        description: jobInfo.description,
        permissionIds: this.checkPermissionIds.join(','),
        generalPermission: jobInfo.generalPermission,
        delPriv: jobInfo.delPriv
      }

      if (this.routerQuery.type === 'copy') {
        params.pubPriv = jobInfo.pubPriv
        params.delPriv = jobInfo.delPriv
      }

      if (this.routerQuery.id && this.routerQuery.type !== 'copy') {
        params.id = this.routerQuery.id
      }
      enterpriseJobEditApi(params).then(res => {
        SpMessage({
          message: res.message,
          type: 'success'
        })
      })
    },

    // 获取职位职位详情
    getEnterpriseCorpDetail () {
      if (this.routerQuery?.id) {
        getEnterpriseJobDetailApi(this.routerQuery.id).then(res => {
          this.jobInfo = res.data

          const permissionIds = res.data.permissionIds
          const permissions = res.data.permissions
          const parentIds = permissions.map(item => item.parentId)
          const formatPermissionIds = permissionIds.concat(parentIds).filter(item => !parentIds.includes(item))

          this.jobInfo.identity = this.jobInfo.identity.toString()
          this.searchProfession(this.jobInfo.identity, 'auto', false)
          this.searchPosition(this.jobInfo.professionId)

          this.jobInfo.professionId = res.data.professionId
          this.jobInfo.positionId = res.data.positionId
          this.defaultCheckedKeys = permissionIds
        })
      }
    },

    // 获取权限映射关系
    getJobPermissionMap () {
      getJobPermissionMapApi().then(res => {
        if (res.code === 1) {
          this.jobPermissionMap = res.data
        }
      })
    },

    toChangePermission (is, ids, key, chKey, keys) {
      if (!is) {
        if (chKey.includes('All')) {
          this.defaultCheckedKeys = [...this.checkPermissionIds, ...ids]
          nextTick(() => {
            this.jobInfo.generalPermission[key][keys[1]] = 1
          })
        } else {
          let p = []
          _forEach(this.psArr, ps => {
            if (ids.includes(ps.id)) {
              return p.push(ps)
            }
          })
          p = _uniq(p.map(i => i.parentId))

          this.defaultCheckedKeys = [...this.checkPermissionIds, ...ids]
        }
      } else {
        if (chKey.includes('All')) {
          this.defaultCheckedKeys = _without(this.checkPermissionIds, ...ids)
          this.jobInfo.generalPermission[key][keys[1]] = 0
          nextTick(() => {
            this.jobInfo.generalPermission[key][keys[1]] = 0
          })
        } else {
          let p = []
          _forEach(this.psArr, ps => {
            if (ids.includes(ps.id)) {
              return p.push(ps)
            }
          })
          p = _uniq(p.map(i => i.parentId))

          this.defaultCheckedKeys = _without(this.checkPermissionIds, ...ids)
        }
      }
    },

    setJobGeneralPermission () {
      this.jobInfo.generalPermission = {}
      const i = parseInt(this.jobInfo.identity) || parseInt(this.routerQuery.identity)
      const permissions = this.identityPermissionMap?.permissions || this.jobPermissionMap[i]
      _forEach(permissions, (per, key) => {
        const obk = _camelCase(key)
        const childKeys = Object.keys(per).map(i => _camelCase(i))
        this.jobInfo.generalPermission[obk] = {}
        this.jobInfo.generalPermission[obk] = {
          [childKeys[0]]: 1,
          [childKeys[1]]: 1
        }
      })
    },

    setGeneralPermission (checkedKeys) {
      const i = parseInt(this.jobInfo.identity) || parseInt(this.routerQuery.identity)
      const permissionMap = this.identityPermissionMap?.permissions || this.jobPermissionMap[i]
      const map = {}
      _forEach(permissionMap, (per, key) => {
        const obk = _camelCase(key)
        const childKeys = Object.keys(per).map(i => _camelCase(i))
        const childValues = Object.values(per)
        if (_intersection(checkedKeys, childValues[0]).length === 0) {
          this.jobInfo.generalPermission[obk][childKeys[0]] = 0
          // this.jobInfo.generalPermission[obk][childKeys[1]] = 0
        }
        if (_intersection(checkedKeys, childValues[1]).length === 0) {
          this.jobInfo.generalPermission[obk][childKeys[1]] = 0
        }

        if (_includes(checkedKeys, ...childValues[0])) {
          this.jobInfo.generalPermission[obk][childKeys[0]] = 1
          // this.jobInfo.generalPermission[obk][childKeys[1]] = 1
        }
        if (_intersection(checkedKeys, childValues[1]).length > 0) {
          this.jobInfo.generalPermission[obk][childKeys[1]] = 1
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
.AddResponsibilities {
  .three-dimensional-small{
    min-width: 710px;
    overflow: hidden;
    .top {
      position: relative;
      background-color: #FAFAFA;
      left: 11px;
      top: 9px;
      width: 90%;
      height: 20px;
      transform: skewX(47deg);
    }
    .left {
      border: none;
      background-color: #ECECEC;
      width: 60px;
      transform: skewY(16deg);
      position: relative;
      height: 287px;
      top: -3px;
    }
    .dimensional-content{
      padding: 0;
      position: relative;
      margin-right: 0px;
      top: 6px;
      /* left: 2px; */
      height: 287px;
      background-color: rgba(189, 189, 189, 0.5);
      .content-item{
        line-height: 47px;
        height: 47px;
        color: #FFFFFF;
        .text-left{
          padding-left: 15px;
        }
        .radio-label{
          color: #FFFFFF !important;
        }
        &.odd{
          background-color: #e5e5e5;
          color: #000;
          .radio-label{
            color: #000 !important;
          }
        }
        &.blue{
          background-color: #c3d4d7;
        }

        .item-title{
          text-align: right;
          width: 210px;
        }
        .comp-radio{
          display: inline-block;
          &.black{
            display: block;
          }
          margin-top: 0;
          p{
            margin: 0;
          }
          .tip{
            font-size: 18px;
          }
        }
      }
      .radio-label{
        //font-size: 14px !important;
        font-style: italic;
        opacity: 1 !important;
      }
      .dimensional-content-p{
        color: #FFFFFF;
        opacity: 0.5;
      }
    }
  }
  .position-title{
    position: relative;
    z-index: 99;
    top:5px;
  }
  .opacity {
    opacity: .7;
  }

  > .content {
    padding: @gap*1.5 @gap*2 @gap @gap*2;
    font-weight: 500;

    .left-side {
      padding: @gap*2 @gap*2 @gap*3 @gap*2;
    }

    .right-side {
      .card-content {
        padding: @gap @gap @gap*3 @gap*2;

        .tags-font {
          font-size: 14px;
        }
      }
    }
  }

  .buttons {
    padding: @gap*2 @gap*2 @gap*2 @gap*5;
  }
}
</style>

<style lang="less">
.AddResponsibilities{
  .el-tree-node__label{
    font-size: 16px;
  }
  .el-checkbox{
    --el-checkbox-font-size: 17px;
    --el-checkbox-font-weight: var(--el-font-weight-primary);
    --el-checkbox-text-color: var(--el-text-color-regular);
    --el-checkbox-input-height: 17px;
    --el-checkbox-input-width: 17px;

  }
  .el-checkbox__input{
    position: relative;
    top: 2px;
  }
  .el-checkbox__inner::after {
    box-sizing: content-box;
    content: "";
    border: 3px solid #FFFFFF;
    border-left: 0;
    border-top: 0;
    height: 12px;
    left: 4px;
    position: absolute;
    top: -2px;
    transform: rotate(45deg) scaleY(0);
    width: 5px;
    transition: transform .15s ease-in 50ms;
    transform-origin: center;
  }
  .el-checkbox__input.is-indeterminate .el-checkbox__inner::before {
    content: "";
    position: absolute;
    display: block;
    background-color: var(--el-checkbox-checked-icon-color);
    height: 4px;
    transform: scale(.5);
    left: -1px;
    right: 0;
    width: 17px;
    top: 6px;
  }
  .el-checkbox__inner{
    &:hover {
      border-color: #3A909D;
    }
  }
  .el-checkbox__input{
    &.is-checked {
      .el-checkbox__inner{
        background-color: #3A909D ;
        border-color: #3A909D
      }
    }
    &.is-indeterminate{
      .el-checkbox__inner{
        background-color: #3A909D ;
        border-color: #3A909D
      }
    }
  }
  .el-tree-node__children{

    .el-tree-node{
      //display: inline-block;
      float: left;
    }
  }
  .small-select{
    .clear-icon{
      font-size: 14px !important;
      font-weight: normal !important;
    }
  }
}
</style>
